import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Form, Dropdown } from 'semantic-ui-react'
import { useTenantStore } from '../../../../../stores/tenantStore.js'
import { FEATURES } from '../../../../../lib/config/constants.js'

/**
 * FreightTypeFilter
 *
 * Freight type select filter.
 * Options come from the tenant feature config in tenantStore. The freight
 * types live under features['freight_type_location_by_place_id'].enabled as an
 * object map keyed by freight key: { [freightKey]: { display_name, ... } }.
 */
export const FreightTypeFilter = ({ value, onChange, placeholder, label }) => {
  const features = useTenantStore((s) => s.features)

  // Build freight type options from the tenant feature object map.
  const options = useMemo(() => {
    const allFreightTypes =
      features?.[FEATURES.FREIGHT_TYPE_LOCATION_BY_PLACE_ID.name]?.enabled || {}

    return Object.entries(allFreightTypes).map(([freightKey, ft]) => ({
      key: freightKey,
      value: freightKey,
      text: ft?.display_name || ft?.name || freightKey,
      data: {
        value: freightKey,
        name: ft?.display_name || ft?.name || freightKey,
        display_name: ft?.display_name || ft?.name || freightKey,
      },
    }))
  }, [features])

  // Handle selection change
  const handleChange = (e, { value: selectedValue }) => {
    const selectedType = options.find((opt) => opt.value === selectedValue)
    onChange(selectedType?.data || null)
  }

  // Get current value for dropdown
  const dropdownValue = value?.value || value || ''

  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        placeholder={placeholder}
        fluid
        selection
        search
        clearable
        options={options}
        value={dropdownValue}
        onChange={handleChange}
        noResultsMessage='No freight types available'
      />
    </Form.Field>
  )
}

FreightTypeFilter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
}

FreightTypeFilter.defaultProps = {
  value: null,
  placeholder: 'Select freight type...',
  label: 'Freight Type',
}
